'use client';
import React from 'react';
import { withDefaultValues } from '../withDefaultValues';
export const EditItalicIcon = withDefaultValues((props: React.SVGProps<SVGSVGElement>) => <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M14 18H8v-2h2l2-9h-2V5h6v2h-2l-2 9h2v2z" fill="currentColor" /></svg>);